import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Form from "react-bootstrap/Form";
import Sidebar from "../components/Sidebar";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useForm } from "react-hook-form";
import axios from "axios";
import { BASE_URL, CHANGE_PASSWORD } from "../API";
import { toast } from "react-toastify";
import { RiEyeLine, RiEyeOffLine } from "react-icons/ri";

function ChangePassword() {
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors }, reset, watch } = useForm();
  const TOKEN = localStorage.getItem('token');
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const new_password = watch('new_password');

  const togglePasswordVisibility = () => { setShowPassword(!showPassword); };
  const togglePasswordVisibility1 = () => { setShowPassword1(!showPassword1); };
  const togglePasswordVisibility2 = () => { setShowPassword2(!showPassword2); };

  const handleChangePass = async (data) => {
    data.language = 'ENGLISH'
    try {
      const response = await axios.put(BASE_URL + CHANGE_PASSWORD, data, { headers: { token: TOKEN } });
      if (response.data.code === 200 && response.data.status === true) {
        toast.success(response.data.message);
        reset();
        navigate('/profile')
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const errorMessage = error.response.data.error_description || "An error occurred";
        toast.error(errorMessage);
      } else {
        toast.error("An error occurredsss");
      }
    }
  }

  return (
    <>
      <>
        <div className="container-fluid">
          <Header />
          <div className="row">
            <Sidebar />
            <div className="col-9 main-dash-left">
              <h3 className="heading-view-med">Change password</h3>
              <section>
                <div className="comn-back-white">
                  <div className="comm_form_border_box  mt-4">
                    <section className="back-comn-img">
                      <div className="custm-container">
                        <div className="edit-profile-amin">
                          <Form onSubmit={handleSubmit(handleChangePass)}>
                            <Row>
                              <Col md={6}>
                                <Form.Group className="comn-class-inputs marg-b-20">
                                  <Form.Label>Old Password</Form.Label>
                                  <div className="cstPassGroup">
                                    <Form.Control
                                      type={showPassword ? "text" : "password"}
                                      placeholder="Enter Old Password"
                                      {...register("old_password", { required: 'Please enter old password.' }
                                      )}
                                    />
                                    {errors.old_password && <span className="error">{errors.old_password.message}</span>}
                                    <div onClick={togglePasswordVisibility} className="eyeToggleBtn">
                                      {showPassword ? (<RiEyeLine />) : (<RiEyeOffLine />)}
                                    </div>
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className="comn-class-inputs marg-b-20">
                                  <Form.Label>New Password</Form.Label>
                                  <div className="cstPassGroup">
                                    <Form.Control
                                      type={showPassword1 ? "text" : "password"}
                                      placeholder="Enter New Password"
                                      {...register("new_password", {
                                        required: 'Please enter new password.',
                                        pattern: {
                                          value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/,
                                          message: "New password must be at least 8 characters long with uppercase, lowercase, number, special character, and no spaces.                                "
                                        }
                                      })}
                                    />
                                    {errors.new_password && <span className="error">{errors.new_password.message}</span>}
                                    <div onClick={togglePasswordVisibility1} className="eyeToggleBtn">
                                      {showPassword1 ? (<RiEyeLine />) : (<RiEyeOffLine />)}
                                    </div>
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className="comn-class-inputs marg-b-20">
                                  <Form.Label>Confirm New Password</Form.Label>
                                  <div className="cstPassGroup">
                                    <Form.Control
                                      type={showPassword2 ? "text" : "password"}
                                      placeholder="Confirm New Password"
                                      {...register("confirm_password", {
                                        required: 'Please enter confirm new password.',
                                        validate: value => value === new_password || 'New password and confirm new password does not match..'
                                      })}
                                    />
                                    {errors.confirm_password && <span className="error">{errors.confirm_password.message}</span>}
                                    <div onClick={togglePasswordVisibility2} className="eyeToggleBtn">
                                      {showPassword2 ? (<RiEyeLine />) : (<RiEyeOffLine />)}
                                    </div>
                                  </div>
                                </Form.Group>
                              </Col>
                            </Row>
                            <div className="pair-btns-comn d-flex align-items-center gap-3 mt-3">
                              <Button className="comn-btn-pair" type="submit">
                                Update
                              </Button>
                              <Button className="comn-btn-pair back-white-btn" onClick={() => navigate('/profile')}>
                                Cancel
                              </Button>
                            </div>
                          </Form>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </>
    </>
  );
}

export default ChangePassword;
